"use client";

import { useDataLayerContext } from "@/datalayer/DataLayerContextProvider";
import useIntelliSuggestTracking from "@/hooks/useIntelliSuggestTracking";
import {
	IntelliSuggestItem,
	ProductData,
	SearchDropdownProduct,
} from "@/lib/5874/types";
import { StoreRegion } from "@/lib/builder/builder.config";
import { BigCommerceStoreContext } from "@/providers/BigCommerceStoreProvider";
import { ReactNode, useContext } from "react";

type Props = {
	children: ReactNode;
	datalayerProduct: ProductData | undefined;
	product: SearchDropdownProduct;
	referrer: string;
	path: string;
	manageCloseDropdown: () => void;
	store: StoreRegion;
};
const IntellisuggestProductClickEvent: React.FC<Props> = ({
	children,
	datalayerProduct,
	product,
	manageCloseDropdown,
	store,
}: Props) => {
	// Datalayer
	const { selectItem } = useDataLayerContext();
	const { currencyFormattingRules } = useContext(BigCommerceStoreContext);
	const scope = "search_dropdown";

	const updatedProduct = addIntellisuggestToProduct(
		datalayerProduct as ProductData,
		product,
	);

	// Intellisuggest
	const { productClick } = useIntelliSuggestTracking();

	const handleSelectItem = () => {
		if (datalayerProduct !== undefined) {
			selectItem(
				datalayerProduct,
				datalayerProduct.id,
				scope,
				datalayerProduct?.categories[0]?.name ?? scope,
				currencyFormattingRules.currency,
			);
		}
		if (datalayerProduct) {
			productClick(datalayerProduct);
		}
		manageCloseDropdown();
	};

	return <section onClick={handleSelectItem}>{children}</section>;
};

export default IntellisuggestProductClickEvent;

function addIntellisuggestToProduct(
	product: ProductData,
	intellisuggestItem?: IntelliSuggestItem,
): ProductData {
	if (!intellisuggestItem) {
		return product;
	}

	return {
		...product,
		intellisuggestData: intellisuggestItem.intellisuggestData,
		intellisuggestSignature: intellisuggestItem.intellisuggestSignature,
	};
}
